namespace Ir.Components.Email.AddressListEditor {
    interface IViewModel {
        gridOptions: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;
        tabComponent: DevExpress.ui.dxTabPanel;

        mappingsGridComponent: DevExpress.ui.dxDataGrid;

        emailAddresses: Array<AddressList>;
        companies: Array<Classes.Models.Company>;
        organisations: Array<Organization>;
    }
    interface IParams { }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        load(self);

        let store = new DevExpress.data.CustomStore({
            key: "id",
            load: function (loadOptions) {
                return self.emailAddresses;
            },
            insert: function (newAddress: AddressList) {
                var d = $.Deferred();

                let o = {
                    url: urlConfigs.email + "/SaveAddress",
                    data: newAddress,
                    successFunction(id, e) {
                        newAddress.id = id;
                        for (let mappingFilter of newAddress.mappingFilters) {
                            mappingFilter.addressList = id;
                        }

                        self.emailAddresses.push(newAddress);
                        d.resolve(newAddress);
                    },
                    failureFunction(textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to save address list";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);

                        d.resolve(false);
                    },
                    async: false,
                    verb: "POST",
                    dataType: "json"
                } as RequestServerParams;
                irGlobal.requestServer(o);

                return d.promise as any;
            },
            update: function (key, values) {
                var d = $.Deferred();

                var url = urlConfigs.email + "/SaveAddress";
                var filtered = self.emailAddresses.filter(function (value, index, arr) {
                    return value.id === key;
                });
                if (filtered.length === 1) {
                    let address = filtered[0];
                    Object.assign(address, values);
                    irGlobal.updateFromServer({},
                        url,
                        address,
                        null,
                        function (textStatus, errorThrown, errorItem: IError) {
                            errorItem.userMessage = "Failed to update address list";
                            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                        },
                        true,
                        "POST",
                        true);
                }

                d.resolve();
                return d.promise();
            },
            remove: function (key) {
                var d = $.Deferred();

                var url = urlConfigs.email + "/DeleteAddress/" + key;
                irGlobal.updateFromServer({},
                    url,
                    { id: key },
                    function (result) {
                        if (result.isValid) {
                            var filtered = self.emailAddresses.filter(function (value, index, arr) {
                                return value.id !== key;
                            });
                            self.emailAddresses = filtered;
                            d.resolve();
                        }
                        else {
                            DevExpress.ui.notify(result.message);
                            d.resolve(false);
                        }
                    },
                    function (textStatus, errorThrown, errorItem: IError) {
                        errorItem.userMessage = "Failed to delete address list";
                        irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                    },
                    true,
                    "POST",
                    true);
                 return d.promise();
            }
        });

        let currentAddressList: AddressList = null;
        let clonedMappingFilters: Array<AddressMappingFilter> = [];
        let formComponent: DevExpress.ui.dxForm = null;
        this.gridOptions = {
            width: "100%",
            height: "100%",
            keyExpr: 'id',
            dataSource: store,
            columns: [{
                dataField: "id",
                width: 100,
                visible: false
            },
                "name", {
                dataField: "description",
                visible: false
            }, {
                dataField: "organisationId",
                caption: "Organisation",
                visible: irSettings.multiTenant,
                setCellValue(rowData, value) {
                    (this as any).defaultSetCellValue(rowData, value);
                    rowData.companyId = 0;
                },
                lookup: {
                    dataSource: self.organisations || [],
                    displayExpr: 'name',
                    valueExpr: 'id',
                }
            },{
                dataField: "companyId",
                caption: "Company",
                visible: irSettings.multiTenant,
                lookup: {
                    dataSource(options) {
                        return {
                            store: self.companies || [],
                            filter: options.data ? [['organisationId', '=', options.data.organisationId], 'or', ['organisationId', '=', 0]] : null,
                        };
                    },
                    displayExpr: 'name',
                    valueExpr: 'id',
                }
            }, {
                dataField: "connectionString",
                caption: "Connection String",
                visible: false
            }, {
                dataField: "sqlStatement",
                caption: "Sql Statement",
                visible: false
            }, {
                dataField: "mappingFilters",
                visible: false,
                editCellTemplate: function (cellElement, cellInfo) {
                    currentAddressList = cellInfo.data as AddressList;
                    clonedMappingFilters = [...currentAddressList.mappingFilters.map(x => Object.assign({}, x))];

                    let divGrid = $("<div id='mappingFilters'>").dxDataGrid({
                        height: 420,
                        width: "100%",
                        dataSource: currentAddressList.mappingFilters,
                        keyExpr: "id",
                        columns: [
                            {
                                dataField: "mapping",
                                caption: "Mapping",
                                lookup: {
                                    dataSource: MappingService.mappings,
                                    displayExpr: 'name',
                                    valueExpr: 'id',
                                },
                                setCellValue(rowData: AddressMappingFilter, value: number, currentRowData: AddressMappingFilter) {
                                    rowData.mapping = value;

                                    let mapping = MappingService.getMapping(value);
                                    let filterId = rowData.filter ?? currentRowData.filter;
                                    if (mapping && filterId && mapping.filters.filter(x => x.id === filterId).length) {
                                        rowData.filter = null;
                                    }
                                },
                                validationRules: [{ type: 'required' }]
                            },
                            {
                                dataField: "filter",
                                caption: "Filter",
                                lookup: {
                                    dataSource: [],
                                    displayExpr(e: FilterTemplate) {
                                        return replaceBasicHtmlContent(e?.variable ?? e?.name);
                                    },
                                    valueExpr: 'id',
                                },
                                cellTemplate(container, options) {
                                    const rowData = options.data as AddressMappingFilter;
                                    const mapping = MappingService.getMapping(rowData.mapping);
                                    const filterTemplate = mapping ? mapping.getFilter(rowData.filter) : null;
                                    const text = replaceBasicHtmlContent(filterTemplate?.variable ?? filterTemplate?.name ?? "");

                                    container.text(text).attr('title', text);
                                },
                                setCellValue(rowData: AddressMappingFilter, value: number, currentRowData: AddressMappingFilter) {
                                    let oldFilter = rowData.filter ?? currentRowData.filter;
                                    rowData.filter = value;

                                    if (oldFilter) {
                                        let isUsed = !checkMappingFilterRemove(currentRowData.addressList, rowData.mapping ?? currentRowData.mapping, oldFilter);
                                        if (isUsed) {
                                            DevExpress.ui.dialog.alert(`All scheduled emails that use the filter will be changed`, "Address List");
                                        }
                                    }
                                },
                                validationRules: [{ type: 'required' }]
                            }
                        ],                        
                        paging: {
                            enabled: false
                        },
                        scrolling: {
                            useNative: false
                        },
                        showBorders: false,
                        editing: {
                            mode: 'cell',
                            allowUpdating: true,
                            allowDeleting: true,
                            allowAdding: true,
                            useIcons: true,
                            confirmDelete: false
                        }, 
                        toolbar: {
                            items: [
                                {
                                    name: "addRowButton",
                                    location: "before",
                                    widget: 'dxButton',
                                    options: {
                                        icon: "edit-button-addrow",
                                        onClick: function (e) {
                                            let mappingsUsed = currentAddressList.mappingFilters.map(x => x.mapping);
                                            if (MappingService.mappings.filter(x => !mappingsUsed.includes(x.id)).length === 0) {
                                                DevExpress.ui.dialog.alert(`All possible mappings have been defined for this address list`, "Address List");
                                                return;
                                            }

                                            divGrid.dxDataGrid("instance").addRow();
                                        }
                                    }
                                }
                            ]
                        },
                        onInitialized(e) {
                            self.mappingsGridComponent = e.component;
                        },
                        onInitNewRow: function (e) {
                            let newRow = new AddressMappingFilter(null);
                            newRow.addressList = currentAddressList.id;                            
                            e.data = newRow;
                        },
                        onEditorPreparing: function (e) {
                            if (e.parentType === "dataRow") {
                                let mappingFilter = e.row.data as AddressMappingFilter;
                                let mapping = MappingService.getMapping(mappingFilter.mapping);

                                if (e.dataField === "mapping") {
                                    const mappingsUsed = currentAddressList.mappingFilters.map(x => x.mapping);
                                    e.editorOptions.dataSource = MappingService.mappings.filter(x => x.id === mappingFilter.mapping || !mappingsUsed.includes(x.id));
                                    e.editorOptions.disabled = mappingFilter.mapping > 0;
                                    //e.editorOptions.onValueChanged = (valueChangeEvent: any) => {
                                    //    e.component.cellValue(e.row.rowIndex, 'mapping', valueChangeEvent.value);
                                    //    e.component.saveEditData();
                                    //};
                                }
                                else if (e.dataField === "filter") {
                                    const filtersUsed = currentAddressList.mappingFilters.map(x => x.filter);
                                    const filters = mapping ? mapping.filters.filter(x => x.id === mappingFilter.filter || !filtersUsed.includes(x.id)) : [];
                                    e.editorOptions.dataSource = filters;
                                    e.editorOptions.itemTemplate = function (data: FilterTemplate) {
                                        let style = "";
                                        if (data.originalVisibility === VisibilityEnum.Deprecated) {
                                            style = "color: #afadad;";
                                        }

                                        return `<div style="${style}">${(replaceBasicHtmlContent(data.variable ?? data.name))}</div>`;
                                    }
                                    e.editorOptions.onValueChanged = (valueChangeEvent: any) => {
                                        e.component.cellValue(e.row.rowIndex, 'filter', valueChangeEvent.value);
                                        e.component.saveEditData();
                                    };
                                }
                            }
                        },
                        onSaved: function (e) {
                            for (let row of e.changes) {
                                let mappingFilter = row.data as AddressMappingFilter;
                                if (row.type === "insert") {
                                    if (!currentAddressList.mappingFilters.find(x => x.id === mappingFilter.id)) {
                                        currentAddressList.mappingFilters.push(mappingFilter);
                                    }
                                }
                            }

                            cellInfo.setValue(currentAddressList.mappingFilters);
                        },
                        onRowRemoving(e) {
                            let mappingFilter = e.data as AddressMappingFilter;
                            let allow = checkMappingFilterRemove(mappingFilter.addressList, mappingFilter.mapping, mappingFilter.filter);
                            if (!allow) {
                                DevExpress.ui.dialog.alert(`It is not possible to remove it because there are scheduled emails using it`, "Address List");
                                e.cancel = true;
                            }
                        },
                        onRowRemoved: function (e) {
                            const index = currentAddressList.mappingFilters.indexOf(e.data);
                            if (index > -1) {
                                currentAddressList.mappingFilters.splice(index, 1);
                            }

                            cellInfo.setValue(currentAddressList.mappingFilters);
                        }
                    });

                    return divGrid;
                }
            }, {
                type: "buttons",
                buttons: [{
                    name: "edit"
                }, {
                    name: "delete"
                }, {
                    hint: "Clone",
                    icon: "copy",
                    onClick: function (e) {
                        let clonedItem = new AddressList(e.row.data);
                        clonedItem.name += " - Copy";
                        clonedItem.id = 0;

                        for (let mappingFilter of clonedItem.mappingFilters) {
                            mappingFilter.addressList = 0;
                        }

                        store.insert(clonedItem);
                        self.gridComponent.refresh().then(() => {
                            let newItem = self.emailAddresses[self.emailAddresses.length - 1];
                            e.component.option("focusedRowKey", newItem.id);
                        })
                    }
                }, {
                    hint: "Address List Info",
                    icon: "contentlayout",
                    onClick: function (e) {
                        Ir.Components.General.ForeignKeyInfo.show({
                            title: `Address List Info: ${e.row.data.name}`,
                            url: `${urlConfigs.email}/AddressListInfo/${e.row.data.id}`,
                            createTabs(result) {
                                return [
                                    {
                                        name: "Scheduled Emails",
                                        dataSource: result.scheduledEmails,
                                        columns: [                                                
                                            { dataField: "scheduledEmailId", caption: "Id", dataType: "string" },                                                
                                            { dataField: "scheduledEmailName", caption: "Name" },
                                            { dataField: "workbookName", caption: "Workbook" },
                                            {
                                                type: 'buttons',
                                                width: 50,
                                                buttons: [{
                                                    hint: 'Open workbook',
                                                    icon: 'link',
                                                    onClick(e) {
                                                        let o = {
                                                            url: `${urlConfigs.tabs}CanAccessWorkbook`,
                                                            data: {
                                                                userId: loggedUser.id(),
                                                                workbookId: e.row.data.workbookId,
                                                                companyId: loggedUser.companyId()
                                                            },
                                                            dataType: "json",
                                                            async: false,
                                                        } as RequestServerParams;
                                                        o.successFunction = function (data) {
                                                            if (data.success) {
                                                                window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}`, '_blank').focus();
                                                            }
                                                            else {
                                                                DevExpress.ui.notify(data.message);
                                                            }
                                                        };
                                                        o.failureFunction = function () {
                                                            DevExpress.ui.notify("Workbook not found or no access permission");
                                                        };

                                                        irGlobal.requestServer(o);
                                                    }
                                                }],
                                            }
                                        ]
                                    }
                                ];
                            }
                        } as Ir.Components.General.ForeignKeyInfo.IForeignKeyInfoParams);
                    }
                }]
            }
            ],
            showBorders: true,
            focusedRowEnabled: true,
            focusedRowIndex: 0,
            loadPanel: { enabled: false },
            scrolling: {
                useNative: false
            },
            editing: {
                mode: 'popup',
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: 'Address List',
                    showTitle: true,
                    width: 700,
                    height: 630,
                    onShowing(e) {
                        let toolbarItems = e.component.option('toolbarItems');

                        let saveButton = toolbarItems[0];
                        saveButton.options.stylingMode = "contained";
                        saveButton.options.type = "default";
                        saveButton.options.icon = "save";

                        let cancelButton = toolbarItems[1];
                        cancelButton.options.icon = "revert";
                        e.component.option('toolbarItems', toolbarItems);
                    },
                    onShown(e) {
                        if (self.mappingsGridComponent) {
                            self.mappingsGridComponent.updateDimensions();
                        }
                    }
                },
                form: {
                    onInitialized(e) {
                        formComponent = e.component
                    },
                    items: [{
                        itemType: 'group',
                        colCount: 1,
                        colSpan: 2,
                        items: [{
                            dataField: "name",
                            editorType: 'dxTextBox',
                            editorOptions: {
                                maxLength: 120
                            },
                            validationRules: [{ type: 'required' }]
                        }]
                    },
                    {
                        itemType: 'tabbed',
                        colCount: 1,
                        colSpan: 2,
                        tabPanelOptions: {
                            deferRendering: false,
                            width: "100%",
                            height: 490,
                            onInitialized(e) {
                                self.tabComponent = e.component;
                            },
                            onSelectionChanging(e) {
                                if (e.addedItems[0].title === "Mappings") {
                                    const result = formComponent.validate();
                                    e.cancel = new Promise((resolve) => {
                                        result.complete.then((res) => {
                                            resolve(!res.isValid); // resolve true = cancelar
                                        });
                                    });
                                }
                            }
                        },
                        tabs: [{
                            title: "Address List",
                            items: [{
                                itemType: 'group',
                                colCount: 1,
                                colSpan: 2,
                                items: [{
                                    dataField: 'description',
                                    editorType: 'dxTextArea',
                                    editorOptions: {
                                        height: 100,
                                        maxLength: 600
                                    },
                                    //validationRules: [{ type: 'required' }]
                                }, {
                                    dataField: "organisationId"
                                }, {
                                    dataField: "companyId"
                                }, {
                                    dataField: 'connectionString',
                                    editorOptions: {
                                        maxLength: 600
                                    },
                                    validationRules: [
                                        { type: 'required' },
                                        {
                                            type: 'async',
                                            message: 'Could not access database with this Connection String',
                                            validationCallback(params) {
                                                const d = $.Deferred();

                                                $.ajax({
                                                    url: urlConfigs.email + "/ValidConnectionString",
                                                    type: 'POST',
                                                    dataType: 'json',
                                                    contentType: 'application/json',
                                                    data: getDataValidationCallback(self, params, "connectionString")
                                                }).done(function (res) {
                                                    res.isValid ? d.resolve() : d.reject(res.message);
                                                }).fail(function (error) {
                                                    d.reject("Cannot contact validation server");
                                                });

                                                return d.promise();
                                            }
                                        }
                                    ]
                                }, {
                                    dataField: 'sqlStatement',
                                    editorType: 'dxTextArea',
                                    editorOptions: {
                                        height: 200
                                    },
                                    validationRules: [
                                        { type: 'required' },
                                        {
                                            type: 'async',
                                            message: 'Sql statement must have an id field and an email field',
                                            validationCallback(params) {
                                                const d = $.Deferred();
                                                $.ajax({
                                                    url: urlConfigs.email + "/ValidSqlStatement",
                                                    type: 'POST',
                                                    dataType: 'json',
                                                    contentType: 'application/json',
                                                    data: getDataValidationCallback(self, params, "sqlStatement")
                                                }).done(function (res) {
                                                    res.isValid ? d.resolve() : d.reject(res.message);
                                                }).fail(function (error) {
                                                    d.reject("Cannot contact validation server");
                                                });

                                                return d.promise();
                                            }
                                        }
                                    ]
                                }]
                            }]
                        }, {
                            title: "Mappings",
                            items: [{
                                itemType: 'group',
                                colCount: 1,
                                colSpan: 2,
                                items: [{
                                    dataField: "mappingFilters",
                                    label: { visible: false }
                                }]
                            }]
                        }]
                    }]
                },
            },
            toolbar: {
                items: [
                    {
                        name: "addRowButton", cssClass: "customAddRowDataGridAdmin", location: "before",
                        widget: 'dxButton',
                        options: {
                            text: 'Create Address List'
                        },

                    },
                    { name: "searchPanel", location: "after" }
                ]
            },
            searchPanel: {
                visible: true,
                highlightSearchText: true,
            },
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onRowInserted(e) {
                self.gridComponent.option("focusedRowKey", e.data.id);
            },
            onEditCanceling(e) {
                currentAddressList.mappingFilters = clonedMappingFilters;
            },
            onInitNewRow(e) {
                e.data = new AddressList(null);
            },
        }
    }

    function load(self: IViewModel) {
        self.emailAddresses = [];
        self.companies = [];
        self.organisations = [];
        
        let o = {
            url: `${urlConfigs.email}/GetAddressList`,
            data: {},
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result: { emailAddresses: Array<any>, companies: Array<any>, organisations: Array<any> }, e) {
            self.emailAddresses = createInstances(AddressList, result.emailAddresses ?? []);
            self.companies = [new Classes.Models.Company({ id: 0, name: "", organisationId: 0 }), ...createInstances(Classes.Models.Company, result.companies ?? [])];
            self.organisations = [new Organization({ id: 0, name: "" }), ...createInstances(Organization, result.organisations ?? [])];
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get address list";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    function checkMappingFilterRemove(addressList: number, mapping: number, filter: number) : boolean {
        let allow = false;
        let o = {
            url: `${urlConfigs.email}/CheckMappingFilterRemove`,
            data: {
                addressList: addressList,
                mapping: mapping,
                filter: filter
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result: { allow: boolean }, e) {
            allow = result.allow
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to check mapping filter";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return allow;
    }

    function getDataValidationCallback(self: IViewModel, options, property) {
        let key = options.validator.option("validationGroup.key");
        let rowOptions = self.gridComponent.getVisibleRows()[self.gridComponent.getRowIndexByKey(key)];
        
        let data = { ...rowOptions.data };
        data[property] = options.value;
        return JSON.stringify(data);
    };
}